enum Injuries {
  Shoulder = 'Shoulder',
  Elbow = 'Elbow',
  LowerBack = 'Lower Back',
  Knee = 'Knee',
  Other = 'Other',
  special ='special',
}

const injuriesQuestion = {
  name: 'injuries',
  title: 'Do you have any past or current injuries that affect how you move or train?',
  description: 'We’ve got injury-friendly alternatives to help you progress safely.',
  descriptionLocation: 'underTitle',
  type: 'checkbox',
  choices: [
    {
      value: Injuries.Shoulder,
      text: 'Shoulder Injury',
    },
    {
      value: Injuries.Elbow,
      text: 'Elbow Injury',
    },
    {
      value: Injuries.LowerBack,
      text: 'Lower back Injury',
    },
    {
      value: Injuries.Knee,
      text: 'Knee Injury',
    },
    {
      value: Injuries.Other,
      text: 'Other Injury',
    },
      {
      value: Injuries.special,
      text: 'special',
      visibleIf: "false",
      hidden: true, // Mark as hidden
    },
  ],
  // showOtherItem: true,
  showNoneItem: true,
  isRequired: true,
};

export {
  Injuries,
  injuriesQuestion,
}